// extracted by mini-css-extract-plugin
export default {"navbar":"AuthHeader_navbar__Io7eH","login":"AuthHeader_login__maiVh","signup":"AuthHeader_signup__wAyss"};